export default "__VITE_ASSET__Df8DN3fI__"